/* eslint-disable no-undef */
import { IAddUser } from "types/customers.type";
import { Iusers } from "types/users.type";
import api from "./ApiService";

const getUsers = (data: any) => {
  return api
    .get<Iusers>(process.env.REACT_APP_API_BASE_URL + `/users?${data}`)
    .then((response: any) => {
      return response;
    });
};

const addUsers = (data: any) => {
  return api
    .post<IAddUser>(process.env.REACT_APP_API_BASE_URL + `/users`, data)
    .then((response: any) => {
      return response;
    });
};

const UserService = {
  getUsers,
  addUsers,
};
export default UserService;
